<template>
  <div class="table-wrap">
    <el-table
      :data="tableData"
      stripe
      style="width: 100%; border: 1px solid #d9d9d9"
      :row-style="{ height: '54px', color: '#262626' }"
      :cell-style="{ 'text-align': 'center' }"
      :header-cell-style="{
        background: '#fafafa',
        color: '#262626',
        'text-align': 'center',
      }"
    >
      <template slot="empty">
        <img
          class="img-no-data"
          v-if="showDefaultImg"
          src="@/assets/images/img_table_no_data.png"
        />
        <div class="noCart" v-if="tabletype">近3个月无提现记录哦</div>
        <div class="noCart" v-else>暂无数据</div>
      </template>
      <el-table-column
        :prop="item.prop"
        :label="item.label"
        v-for="(item, index) in tableField"
        :key="index"
      >
        <template slot-scope="scope">
          <template v-if="item.prop == 'operation'">
            <p
              class="btn-operation"
              v-if="$route.path.includes('/data')"
              @click="viewWorkDetailFn(scope.row)"
            >
              查看详情
            </p>
            <p class="btn-operation" v-else @click="viewBillDetail(scope.row)">
              详情
            </p>
          </template>
          <template>
            <!-- 状态值/货币类型/收益来源/贡献点3位/订单号不变/其他数字类型2位 -->
            <p v-if="item.prop == 'state'">
              {{ scope.row[item.prop] | regroupState }}
            </p>
            <p v-else-if="item.prop == 'money_type'">
              {{ scope.row[item.prop] | regroupMoneyType }}
            </p>
            <p v-else-if="item.prop == 'income_type'">
              {{
                scope.row[item.prop]
                  | regroupIncomeType(
                    scope.row['income_desc'],
                    scope.row['money_type'],
                  )
              }}
            </p>
            <p v-else-if="item.prop == 'contribution'">
              {{ scope.row[item.prop] | regroupComma(3) }}
            </p>
            <p v-else-if="item.prop == 'time'">
              {{ scope.row[item.prop] | regroupDate }}
            </p>
            <p v-else-if="item.prop == 'id'">{{ scope.row[item.prop] }}</p>
            <p v-else-if="scope.row.money_type && scope.row.money_type == 1">
              {{ scope.row[item.prop] | regroupComma(3) }}
            </p>
            <p v-else>{{ scope.row[item.prop] | regroupComma(2) }}</p>
          </template>
        </template>

        <template slot="header" v-if="item.explain">
          <span>{{ item.label }}</span>
          <el-tooltip placement="top">
            <img class="icon" src="@/assets/images/icon_help.png" />
            <p slot="content" style="font-size: 16px; color: #fff">
              {{ item.explain }}
            </p>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="isShowPagination"
      background
      @current-change="handleCurrentChange"
      :current-page="tableInfo.page"
      :page-size="tableInfo.pageSize"
      layout="prev, pager, next,jumper"
      :total="tableInfo.total"
      hide-on-single-page
    >
    </el-pagination>

    <WithdrawDetail
      :detailInfo="detailInfo"
      :openBillDialog="openBillDialog"
      @closeBillDialog="closeBillDialog"
    ></WithdrawDetail>
  </div>
</template>

<script>
import WithdrawDetail from './withdraw/detailDialog';
import { getRecordDetail } from '@/api/income';

export default {
  name: 'homeDayIcon',
  components: {
    WithdrawDetail,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tableField: {
      type: Array,
      default: () => [],
    },
    tableInfo: {
      type: Object,
      default: () => {},
    },
    isShowPagination: {
      type: Boolean,
      default: true,
    },
    tabletype: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogTitle: '实际到账金额',
      detailInfo: {},
      openBillDialog: false,
      showDefaultImg: false,
    };
  },
  watch: {
    tableData(val) {
      val.length ? (this.showDefaultImg = false) : (this.showDefaultImg = true);
    },
  },
  filters: {
    regroupComma(val, num) {
      if (typeof val == 'number') {
        if (val.toString().includes('.')) {
          let reg = /(\d)(?=(\d{3})+\.)/g;
          return val.toFixed(num).toString().replace(reg, '$1,');
        } else {
          let reg = /(\d)(?=(?:\d{3})+$)/g;
          return val.toString().replace(reg, '$1,');
        }
      } else {
        return val;
      }
    },
    regroupState(val) {
      let stateTxt = '';
      switch (val) {
        case 100:
          stateTxt = '待审核';
          break;
        case 101:
        case 102:
          stateTxt = '待打款';
          break;
        case 200:
          stateTxt = '打款成功';
          break;
        case 300:
          stateTxt = '审核失败';
          break;
        case 301:
        case 400:
          stateTxt = '打款失败';
          break;
        default:
          break;
      }
      return stateTxt;
    },
    regroupMoneyType(val) {
      let moneyTypeTxt = '';
      switch (val) {
        case 1:
          moneyTypeTxt = '贡献点';
          break;
        case 2:
          moneyTypeTxt = '迷你豆';
          break;
        case 3:
          moneyTypeTxt = '广告';
          break;
        case 4:
          moneyTypeTxt = '迷你点';
          break;
        case 5:
          moneyTypeTxt = '激励金';
          break;
        default:
          break;
      }
      return moneyTypeTxt;
    },
    regroupIncomeType(val, desc, money_type) {
      let incomeTypeTxt = '';
      console.log(desc);
      switch (val) {
        case 1:
          incomeTypeTxt = '地图';
          break;
        case 2:
          incomeTypeTxt = '资源';
          break;
        case 3:
          incomeTypeTxt = '激励金';
          break;
        default:
          break;
      }
      if (val == 3 && money_type == 5) {
        incomeTypeTxt = desc;
      }
      return incomeTypeTxt;
    },
    regroupDate(timestamp) {
      let time = new Date(timestamp * 1000);
      let year = time.getFullYear();
      const month = (time.getMonth() + 1).toString().padStart(2, '0');
      const date = time.getDate().toString().padStart(2, '0');
      return year + '-' + month + '-' + date;
    },
  },
  mounted() {
    if (this.tableTotal) {
      document.getElementsByClassName(
        'el-pagination__jump',
      )[0].childNodes[0].nodeValue = '跳至';
    }
  },
  methods: {
    async fetchRecordDetail(row) {
      try {
        let data = {
          id: row.id,
          money_type: row.money_type,
        };
        const res = await getRecordDetail(data);
        this.detailInfo = res.data;
      } catch (error) {
        console.log(error);
      }
    },
    viewWorkDetailFn(row) {
      this.$emit('mapDetailsClick', sessionStorage.getItem('activeLabel'));
      this.$router.push({
        path: '/charts/detail',
        query: {
          id: row.id,
        },
      });
    },
    viewBillDetail(row) {
      this.detailInfo = row;
      this.openBillDialog = true;
    },
    closeBillDialog(val) {
      this.openBillDialog = val;
    },
    handleCurrentChange(val) {
      this.$emit('changePage', val);
    },
  },
};
</script>

<style lang="scss" scoped>
$--color-primary: #fd9b21;

.table-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  .icon {
    margin-left: 3px;
    width: 10px;
    height: 10px;
  }
  .el-icon-question {
    color: #8c8c8c;
  }

  .btn-operation {
    color: #2b6ddf;
    cursor: pointer;
  }
}
.income-detail-table {
  width: 100%;
  display: flex;
  flex-direction: column;
  .img-no-data {
    margin: 0 auto;
    margin-top: 10px;
  }
}
.el-pagination {
  text-align: center;
  margin-top: 19px;
}

::v-deep {
  .el-pagination.is-background .el-pager li,
  .el-pagination.is-background button {
    width: 32px;
    height: 32px;
    line-height: 32px;
  }
  .el-pagination.is-background .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
  .el-pagination.is-background .el-pager li:not(.disabled) {
    background-color: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    color: $--color-primary;
    border: 1px solid #ffc973;
    background: #fffaed;
    border-radius: 4px;
  }
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .btn-next {
    background-color: #fff;

    border-radius: 4px;
    border: 1px solid #d9d9d9;
  }
  .el-table__empty-text {
    line-height: 25px;
    margin: 40px 0 50px;
  }
}
</style>
